// Maps a raw lead row (from the leadsfilter_matchmaking RPC, or any endpoint
// that mirrors its field names — e.g. the enriched /lostLeads API) into the
// leadObj shape that <Leadcard /> consumes. Extracted verbatim from the mapping
// that getAllLeads/getMoreData used inline so every tab — including Lost —
// renders the same card from a single source of truth.
export function mapLeadRow(el) {
  return {
    ...el,
    person: {
      name: el?.leadname,
      personId: el?.personid,
    },
    id:
      'VJ' +
      el?.leaddisplayid?.replace(
        el?.leaddisplayid?.substring(8, 12),
        '-' + el?.leaddisplayid?.substring(8, 12)
      ),
    createdAt: el?.created_at,
    last_updated_at: el?.statuschangeddate,
    type: el?.leadtype,
    status: el?.leadstatus,
    leadId: el?.id,
    leadStatus: el?.leadresponse ? el?.leadresponse : 'WARM',
    FOS: {
      name: el?.fosname ? el?.fosname : '-',
      fosId: el?.fosid ? el?.fosid : '-',
    },
    CP: {
      name: el?.cpname ? el?.cpname : '-',
      cpId: el?.cpid ? el?.cpid : '-',
    },
    brandambassador:
      el?.brandambassador ||
      el?.referral?.find((r) => r?.brandambassador)?.brandambassador ||
      el?.LeadsReferral?.brandambassador,
    referrertype:
      el?.referrertype ||
      el?.referral?.find((r) => r?.referrertype)?.referrertype ||
      el?.LeadsReferral?.[0]?.referrertype,
    Sales: {
      name: el?.salesname ? el?.salesname : '-',
      userId: el?.salesid ? el?.salesid : '-',
      email: el?.useremail,
      contactNumber: el?.usercontactnumber,
    },
    unit: {
      status: '',
      allotmentDate: '',
      number: '',
    },
    project: {
      unitType: el?.unittype,
      name: el?.projectname,
    },
    leadDetails: {
      contactNumber: el?.leadcontactnumber,
      leadEmail: el?.leademail,
    },
    // Lineage link to the original Lost lead, when this lead was regenerated.
    // RPC returns it lowercase (regeneratedfromleadid); the lostLeads API uses
    // camelCase — accept either.
    regeneratedFromLeadId: el?.regeneratedfromleadid ?? el?.regeneratedFromLeadId ?? null,
    isverified: el?.isverified ?? false,
    isSelected: false,
  };
}
